// extracted by mini-css-extract-plugin
export default {"melodyVideo":"aO-z","isFullWidth":"bO-z","landingPageVideo":"cO-z","play":"dO-z","iframeVideo":"eO-z","playHidden":"fO-z","fullwidth":"gO-z"};